import {
  INICIA_MATRICULA,
  SALVA_MATRICULA,
  REMOVE_MATRICULA,
  NOVO_MATRICULA,
  BUSCA_MATRICULA_EDICAO,
  INICIO_MATRICULA_SUCESSO,
  SALVA_MATRICULA_SUCESSO,
  REMOVE_MATRICULA_SUCESSO,
  BUSCA_MATRICULA_EDICAO_SUCESSO,
  ATUALIZA_MATRICULA,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_MATRICULA,
  LISTA_MATRICULA_SUCESSO,
  LIMPAR_MATRICULA,
  LISTA_ESCOLAS_MATRICULA,
  LISTA_ESCOLAS_MATRICULA_SUCESSO,
  LISTA_CURSOS_POR_ESCOLA_MATRICULA,
  LISTA_CURSOS_POR_ESCOLA_MATRICULA_SUCESSO,
  LISTA_SERIES_POR_CURSO_MATRICULA,
  LISTA_SERIES_POR_CURSO_MATRICULA_SUCESSO,
  LISTA_TURMAS_POR_SERIE_MATRICULA,
  LISTA_TURMAS_POR_SERIE_MATRICULA_SUCESSO,
  LISTA_ALUNOS_MATRICULA,
  LISTA_ALUNOS_MATRICULA_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA_SUCESSO,
  OCORRENCIAS_DISCIPLINARES_MATRICULA,
  DISPENSA_COMPONENTES_MATRICULA,
  DEIXOU_FREQUENTAR_MATRICULA,
  FALECIDO_MATRICULA,
  RECLASSIFICAR_MATRICULA,
  SOLICITAR_TRANSFERENCIA_MATRICULA,
  MATRICULA_FALECIDO_MODAL_OPEN,
  MATRICULA_FALECIDO_MODAL_CLOSE,
  MATRICULA_FALECIDO_SALVAR,
  MATRICULA_FALECIDO_MODAL_ATUALIZA_CAMPO,
  MATRICULA_FALECIDO_CANCELAR,
  MATRICULA_DEIXOU_MODAL_OPEN,
  MATRICULA_DEIXOU_MODAL_CLOSE,
  MATRICULA_DEIXOU_MODAL_ATUALIZA_CAMPO,
  MATRICULA_DEIXOU_SALVAR,
  MATRICULA_DEIXOU_CANCELAR,
  MATRICULA_RECLASSIFICACAO_MODAL_OPEN,
  MATRICULA_RECLASSIFICACAO_MODAL_CLOSE,
  MATRICULA_RECLASSIFICACAO_SALVAR,
  MATRICULA_RECLASSIFICACAO_MODAL_ATUALIZA_CAMPO,
  MATRICULA_RECLASSIFICACAO_CANCELAR,
  MATRICULA_TRANSFERENCIA_MODAL_OPEN,
  MATRICULA_TRANSFERENCIA_MODAL_CLOSE,
  MATRICULA_TRANSFERENCIA_SALVAR,
  MATRICULA_TRANSFERENCIA_MODAL_ATUALIZA_CAMPO,
  MATRICULA_TRANSFERENCIA_CANCELAR,
  MATRICULA_TRANSFERENCIA_VISUALIZAR,
  MATRICULA_OCORRENCIA_MODAL_OPEN,
  MATRICULA_OCORRENCIA_MODAL_CLOSE,
  LISTA_MATRICULA_OCORRENCIAS,
  LISTA_MATRICULA_OCORRENCIAS_SUCESSO,
  SALVA_MATRICULA_OCORRENCIA,
  REMOVE_MATRICULA_OCORRENCIA,
  LISTA_TIPOS_OCORRENCIA_SUCESSO,
  MATRICULA_DISPENSA_MODAL_OPEN,
  MATRICULA_DISPENSA_MODAL_OPEN_SUCESSO,
  MATRICULA_DISPENSA_MODAL_CLOSE,
  MATRICULA_DISPENSA_MODAL_ATUALIZA_CAMPO,
  MATRICULA_DISPENSA_SALVAR,
  MATRICULA_DISPENSA_SALVAR_SUCESSO,
  MATRICULA_DISPENSA_REMOVER,
  MATRICULA_DISPENSA_REMOVER_SUCESSO,
  LISTA_TIPOS_DISPENSA,
  LISTA_TIPOS_DISPENSA_SUCESSO,
  LISTA_DISPENSAS_MATRICULA,
  LISTA_DISPENSAS_MATRICULA_SUCESSO,
  LISTA_COMPONENTES_ESCOLA_DISPENSA,
  LISTA_COMPONENTES_ESCOLA_DISPENSA_SUCESSO,
  LISTA_PERIODOS_ANO_LETIVO_DISPENSA,
  LISTA_PERIODOS_ANO_LETIVO_DISPENSA_SUCESSO,
  MATRICULA_DISPENSA_BUSCA_MATRICULA_SUCESSO
} from 'constants/ActionTypes';
import { SALVA_TIPO_OCORRENCIA_DISCIPLINAR, ATUALIZA_TIPO_OCORRENCIA_DISCIPLINAR } from 'constants/ActionTypes';

export const iniciaMatricula = () => ({ type: INICIA_MATRICULA });
export const salvaMatricula = (matricula) => ({ type: SALVA_MATRICULA, payload: matricula });
export const atualizaMatricula = (matricula) => ({ type: ATUALIZA_MATRICULA, payload: matricula });
export const removeMatricula = (id) => ({ type: REMOVE_MATRICULA, payload: id });
export const listaMatricula = (filtros) => ({ type: LISTA_MATRICULA, payload: filtros || {} });
export const novoMatricula = () => ({ type: NOVO_MATRICULA });
export const buscaMatriculaEdicao = (id) => ({ type: BUSCA_MATRICULA_EDICAO, payload: id });

export const inicioMatriculaSucesso = (matriculas) => ({ type: INICIO_MATRICULA_SUCESSO, payload: matriculas });
export const salvaMatriculaSucesso = (mensagem) => ({ type: SALVA_MATRICULA_SUCESSO, payload: mensagem });
export const removeMatriculaSucesso = (mensagem) => ({ type: REMOVE_MATRICULA_SUCESSO, payload: mensagem });
export const buscaMatriculaEdicaoSucesso = (matricula) => ({ type: BUSCA_MATRICULA_EDICAO_SUCESSO, payload: matricula });
export const listaMatriculaSucesso = (matriculas) => ({ type: LISTA_MATRICULA_SUCESSO, payload: matriculas });
export const limparFiltroMatricula = () => ({ type: LIMPAR_MATRICULA });

export const exibirMensagemErro = (message) => ({ type: SHOW_MESSAGE, payload: message });
export const showAuthLoader = () => ({ type: ON_SHOW_LOADER });
export const hideMessage = () => ({ type: HIDE_MESSAGE });
export const showAuthMessage = (message) => ({ type: SHOW_MESSAGE, payload: message });
export const showSuccessMessage = (message) => ({ type: ON_SHOW_SUCCESS_MESSAGE, payload: message });

export const listaEscolasMatricula = () => ({ type: LISTA_ESCOLAS_MATRICULA });
export const listaEscolasMatriculaSucesso = (escolas) => ({ type: LISTA_ESCOLAS_MATRICULA_SUCESSO, payload: escolas });
export const listaCursosPorEscolaMatricula = (escolaId) => ({ type: LISTA_CURSOS_POR_ESCOLA_MATRICULA, payload: escolaId });
export const listaCursosPorEscolaMatriculaSucesso = (cursos) => ({ type: LISTA_CURSOS_POR_ESCOLA_MATRICULA_SUCESSO, payload: cursos });
export const listaSeriesPorCursoMatricula = (cursoId) => ({ type: LISTA_SERIES_POR_CURSO_MATRICULA, payload: cursoId });
export const listaSeriesPorCursoMatriculaSucesso = (series) => ({ type: LISTA_SERIES_POR_CURSO_MATRICULA_SUCESSO, payload: series });
export const listaTurmasPorSerieMatricula = (serieId, cursoId, escolaId, ano) => {
  if (typeof serieId === 'object' && serieId !== null) {
    return { type: LISTA_TURMAS_POR_SERIE_MATRICULA, payload: serieId };
  }
  return { type: LISTA_TURMAS_POR_SERIE_MATRICULA, payload: { serieId, cursoId, escolaId, ano } };
};
export const listaTurmasPorSerieMatriculaSucesso = (turmas) => ({ type: LISTA_TURMAS_POR_SERIE_MATRICULA_SUCESSO, payload: turmas });
export const listaAlunosMatricula = (filtro) => ({ type: LISTA_ALUNOS_MATRICULA, payload: filtro || {} });
export const listaAlunosMatriculaSucesso = (alunos) => ({ type: LISTA_ALUNOS_MATRICULA_SUCESSO, payload: alunos });
export const listaAnosLetivosPorEscolaMatricula = (escolaId) => ({ type: LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA, payload: escolaId });
export const listaAnosLetivosPorEscolaMatriculaSucesso = (anos) => ({ type: LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA_SUCESSO, payload: anos });

// Ações pré-definidas de alteração de matrícula
export const ocorrenciasDisciplinaresMatricula = (id) => ({ type: OCORRENCIAS_DISCIPLINARES_MATRICULA, payload: id });
export const dispensaComponentesMatricula = (id) => ({ type: DISPENSA_COMPONENTES_MATRICULA, payload: id });
export const deixouFrequentarMatricula = (id) => ({ type: DEIXOU_FREQUENTAR_MATRICULA, payload: id });
export const falecidoMatricula = (id) => ({ type: FALECIDO_MATRICULA, payload: id });
export const reclassificarMatricula = (id) => ({ type: RECLASSIFICAR_MATRICULA, payload: id });
export const solicitarTransferenciaMatricula = (id) => ({ type: SOLICITAR_TRANSFERENCIA_MATRICULA, payload: id });

// Falecido - modal e salvar
export const openFalecidoModal = (matriculaId) => ({ type: MATRICULA_FALECIDO_MODAL_OPEN, payload: matriculaId });
export const closeFalecidoModal = () => ({ type: MATRICULA_FALECIDO_MODAL_CLOSE });
export const salvarFalecido = (dados) => ({ type: MATRICULA_FALECIDO_SALVAR, payload: dados });
export const atualizaCampoFalecidoModal = (name, value) => ({ type: MATRICULA_FALECIDO_MODAL_ATUALIZA_CAMPO, payload: { name, value } });
export const cancelarFalecido = (matriculaId) => ({ type: MATRICULA_FALECIDO_CANCELAR, payload: matriculaId });

// Deixou de Frequentar - modal e salvar
export const openDeixouModal = (matriculaId) => ({ type: MATRICULA_DEIXOU_MODAL_OPEN, payload: matriculaId });
export const closeDeixouModal = () => ({ type: MATRICULA_DEIXOU_MODAL_CLOSE });
export const salvarDeixouFrequentar = (dados) => ({ type: MATRICULA_DEIXOU_SALVAR, payload: dados });
export const atualizaCampoDeixouModal = (name, value) => ({ type: MATRICULA_DEIXOU_MODAL_ATUALIZA_CAMPO, payload: { name, value } });
export const desfazerDeixouFrequentar = (matriculaId) => ({ type: MATRICULA_DEIXOU_CANCELAR, payload: matriculaId });

// Reclassificação - modal e salvar
export const openReclassificacaoModal = (matriculaId) => ({ type: MATRICULA_RECLASSIFICACAO_MODAL_OPEN, payload: matriculaId });
export const closeReclassificacaoModal = () => ({ type: MATRICULA_RECLASSIFICACAO_MODAL_CLOSE });
export const salvarReclassificacao = (dados) => ({ type: MATRICULA_RECLASSIFICACAO_SALVAR, payload: dados });
export const atualizaCampoReclassificacaoModal = (name, value) => ({ type: MATRICULA_RECLASSIFICACAO_MODAL_ATUALIZA_CAMPO, payload: { name, value } });
export const cancelarReclassificacao = (matriculaId) => ({ type: MATRICULA_RECLASSIFICACAO_CANCELAR, payload: matriculaId });

// Ocorrências Disciplinares - modal e CRUD
export const openOcorrenciasModal = (matriculaId) => ({ type: MATRICULA_OCORRENCIA_MODAL_OPEN, payload: matriculaId });
export const closeOcorrenciasModal = () => ({ type: MATRICULA_OCORRENCIA_MODAL_CLOSE });
export const listaMatriculaOcorrencias = (matriculaId) => ({ type: LISTA_MATRICULA_OCORRENCIAS, payload: matriculaId });
export const listaMatriculaOcorrenciasSucesso = (lista) => ({ type: LISTA_MATRICULA_OCORRENCIAS_SUCESSO, payload: lista });
export const salvarMatriculaOcorrencia = (dados) => ({ type: SALVA_MATRICULA_OCORRENCIA, payload: dados });
export const removerMatriculaOcorrencia = (idOcorrencia) => ({ type: REMOVE_MATRICULA_OCORRENCIA, payload: idOcorrencia });
export const listaTiposOcorrenciaSucesso = (lista) => ({ type: LISTA_TIPOS_OCORRENCIA_SUCESSO, payload: lista });

export const salvarTipoOcorrenciaDisciplinar = (dados) => ({ type: SALVA_TIPO_OCORRENCIA_DISCIPLINAR, payload: dados });
export const atualizarTipoOcorrenciaDisciplinar = (dados) => ({ type: ATUALIZA_TIPO_OCORRENCIA_DISCIPLINAR, payload: dados });

// Transferência - modal e salvar
export const openTransferenciaModal = (matriculaId) => ({ type: MATRICULA_TRANSFERENCIA_MODAL_OPEN, payload: matriculaId });
export const closeTransferenciaModal = () => ({ type: MATRICULA_TRANSFERENCIA_MODAL_CLOSE });
export const salvarTransferencia = (dados) => ({ type: MATRICULA_TRANSFERENCIA_SALVAR, payload: dados });
export const atualizaCampoTransferenciaModal = (name, value) => ({ type: MATRICULA_TRANSFERENCIA_MODAL_ATUALIZA_CAMPO, payload: { name, value } });
export const cancelarTransferencia = (matriculaId) => ({ type: MATRICULA_TRANSFERENCIA_CANCELAR, payload: matriculaId });
export const visualizarTransferencia = (matriculaId) => ({ type: MATRICULA_TRANSFERENCIA_VISUALIZAR, payload: matriculaId });

// Dispensa Curricular - modal e CRUD
export const openDispensaModal = (matriculaId) => ({ type: MATRICULA_DISPENSA_MODAL_OPEN, payload: matriculaId });
export const openDispensaModalSucesso = () => ({ type: MATRICULA_DISPENSA_MODAL_OPEN_SUCESSO });
export const closeDispensaModal = () => ({ type: MATRICULA_DISPENSA_MODAL_CLOSE });
export const atualizaCampoDispensaModal = (name, value) => ({ type: MATRICULA_DISPENSA_MODAL_ATUALIZA_CAMPO, payload: { name, value } });
export const salvarDispensaCurricular = (dados) => ({ type: MATRICULA_DISPENSA_SALVAR, payload: dados });
export const salvarDispensaCurricularSucesso = (mensagem) => ({ type: MATRICULA_DISPENSA_SALVAR_SUCESSO, payload: mensagem });
export const removerDispensaCurricular = (idDispensa) => ({ type: MATRICULA_DISPENSA_REMOVER, payload: idDispensa });
export const removerDispensaCurricularSucesso = (mensagem) => ({ type: MATRICULA_DISPENSA_REMOVER_SUCESSO, payload: mensagem });
export const listaTiposDispensa = () => ({ type: LISTA_TIPOS_DISPENSA });
export const listaTiposDispensaSucesso = (lista) => ({ type: LISTA_TIPOS_DISPENSA_SUCESSO, payload: lista });
export const listaDispensasMatricula = (matriculaId) => ({ type: LISTA_DISPENSAS_MATRICULA, payload: matriculaId });
export const listaDispensasMatriculaSucesso = (lista) => ({ type: LISTA_DISPENSAS_MATRICULA_SUCESSO, payload: lista });
export const listaComponentesEscolaDispensa = (escolaId, cursoId, serieId) => ({ type: LISTA_COMPONENTES_ESCOLA_DISPENSA, payload: { escolaId, cursoId, serieId } });
export const listaComponentesEscolaDispensaSucesso = (lista) => ({ type: LISTA_COMPONENTES_ESCOLA_DISPENSA_SUCESSO, payload: lista });
export const listaPeriodosAnoLetivoDispensa = (escolaId, ano) => ({ type: LISTA_PERIODOS_ANO_LETIVO_DISPENSA, payload: { escolaId, ano } });
export const listaPeriodosAnoLetivoDispensaSucesso = (lista) => ({ type: LISTA_PERIODOS_ANO_LETIVO_DISPENSA_SUCESSO, payload: lista });
export const buscaDispensaMatriculaSucesso = (dados) => ({ type: MATRICULA_DISPENSA_BUSCA_MATRICULA_SUCESSO, payload: dados });
